import * as Yup from "yup";

export const documentSchema = Yup.object().shape({
  description: Yup.string().required("파일 설명을 입력하세요"),
  modifyDate: Yup.date(),

  // NOT DB
  base64: Yup.string(),

  //note not used
  // uid: Yup.number(),
  // guid: Yup.string(),
  // companyUID: Yup.number(),
  // type: Yup.number(), // 서식타입 0 - 공정위험성평가, 1 - 작업위험성평가, 2 - 작업자교육, 3 - 화기작업허가서, 4 - 일반작업허가서, 5 - 변경요구서, 6 - 가동전점검표, 7- 변경구분평가
  // fileType: Yup.number(),
  // fileName: Yup.string(),
  // extension: Yup.string(),
  // isDeleted: Yup.boolean(),
  // entryDate: Yup.date(),
  // revisionDate: Yup.date(),
});
